import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { SkillsBreakdown } from "@/types/admin.types";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface TeamSkillsChartProps {
  data: SkillsBreakdown;
}

export function TeamSkillsChart({ data }: TeamSkillsChartProps) {
  const chartData = Object.entries(data).map(([key, value]) => ({
    subject: key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " "),
    score: Math.min(value, 10),
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-medium">
          Team Skills Breakdown
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="subject" tickLine={false} axisLine={false} />
              <YAxis
                domain={[0, 10]}
                tickLine={false}
                axisLine={false}
                allowDecimals={false}
              />
              <Tooltip
                formatter={(value: number) => [value.toFixed(2), "Score"]}
                contentStyle={{
                  borderRadius: "8px",
                  border: "none",
                  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                }}
              />
              <Bar
                dataKey="score"
                fill="#8b5cf6"
                radius={[4, 4, 0, 0]}
                barSize={50}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
